import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom'
import { Col, Row, Card, CardBody } from 'reactstrap'
import styled from "styled-components"
import { AuthContext } from '../../contexts/AuthContext'
import CourseCard from '../../components/CourseCard'
import api from "../../services/api"
import _ from "lodash"
import CourseStatusEnum from '../../helpers/enums/courseStatus'
import { logout } from '../../auth'
import refreshToken from "../../helpers/tokenHelper"

const StyledDashboardContainer = styled.div`
background-color: rgba(41, 107, 169, 1);
height: 100%;
width: 100%;
overflow: hidden;
`

const StyledDashboardCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    overflow: auto;
    @media (max-width: 768px) {
      flex-direction: column;
      height: 100%;
    }
    @media (min-width: 768px) {
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      height: 80%;
    }
`;

const ColCourse = styled(Col)`
  @media (max-width: 768px) {
      flex: 0 0 50%;
  }
`

const CourseCardContainer = styled(Card)`
border-radius: 15px;
`
const CardBodyClass = styled.div`
display: flex;
flex-direction: column;
align-items: center;
color: #73777f;
font-weight: 600;
min-height: 250px;
`;

const StyledButtonLinkExternal = styled.a`
  color: #fff;
  background-color:  rgba(35, 157, 219, 1);
  border-radius: 20px;
  padding: 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 180px;
  margin-top: auto;
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: rgba(41, 107, 169, 1); 
  }
  &:active {
    font-weight: bold;
  }
`;

const FooterLinks = styled.div`
display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const CardTitle = styled.h5`
  font-weight: bold;
  text-transform: uppercase;
  color: rgb(57, 118, 170);
  font-size: 25px;
`

const StyledLinkToProfile = styled(NavLink)`
  color: #fff;
  text-decoration: none;
  font-size: 24px;
  margin: 0px 25px;
  font-weight: 400;
  &:hover {
    text-decoration: none;
    color: #ddd;
  }
  &:active {
    font-weight: bold;
  }
`

const StyledLinkToLogout = styled.div`
  background-color: #fff;
  padding: 5px 30px;
  border-radius: 50px;
  color: rgb(57, 118, 170);
  text-decoration: none;
  font-size: 24px;
  font-weight: 400;
  margin: 0px 25px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    background-color: #ddd;
    color: rgb(50, 110, 150);
  }
  &:active {
    font-weight: bold;
  }
`

function Dashboard(props) {
  const { dispatch, auth } = useContext(AuthContext);
  const [courses, setCourses] = useState([])
  const [userCourses, setUserCourses] = useState([])

  const refresher = () => {
    api.get('/course').then(res => {
      setCourses(res.courses)
    })
    api.post('/student/get-all-courses', { user: auth.user._id }).then(res => {
      setUserCourses(res.courses)
    })
  }

  useEffect(() => {
    refresher()
    refreshToken(dispatch)
  }, [])


  function logoutFunction() {
    dispatch({ type: "SIGN_OUT" })
    logout()
    props.history.push("/")
  }

  return (
    <StyledDashboardContainer >
      <StyledDashboardCardContainer>
        {courses.map(course => {
          let currentCourse = course;
          const exist = _.find(userCourses, (userCourse) => userCourse._id === course._id)
          if (currentCourse.status === CourseStatusEnum.ENROLL) {
            if (exist) {
              currentCourse = exist
              if (course.enrollDays)
                currentCourse.enrollDays = course.enrollDays
              //# TODO: Modificar o texto depois
              currentCourse.status = 3
            }
          }
          return <ColCourse xs={12} md={3} style={{ marginTop: 10 }} key={`course_${currentCourse._id}`}>
            <CourseCard course={currentCourse} userExist={exist} refresher={refresher} />
          </ColCourse>
        })}
        <ColCourse xs={12} md={3} style={{ marginTop: 10 }}>
          <CourseCardContainer>
            <CardBody className="text-center">
              <CardBodyClass>
                <CardTitle>CURSO DE 2ª E 3ª FASES MPT</CardTitle>
                <span style={{ margin: "40px 0px", marginTop: "auto" }}>Entre em contato para se inscrever em nosso Curso de correções de questões discursivas e peças práticas.</span>
                <StyledButtonLinkExternal target="_blank" href={`https://segundafase.mptgrupo.com.br/login`}>Acessar</StyledButtonLinkExternal>
              </CardBodyClass>
            </CardBody>
          </CourseCardContainer>
        </ColCourse>
      </StyledDashboardCardContainer>
      <FooterLinks>
        {/* TODO remover */}
        {/* <StyledLinkToProfile to="/profile">Meu Perfil</StyledLinkToProfile> */}
        <StyledLinkToLogout onClick={() => { logoutFunction() }}>Logout</StyledLinkToLogout>
      </FooterLinks>
    </StyledDashboardContainer >
  );
}

export default Dashboard;